'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validate;

var _rules = require('../rules.js');

var _rules2 = _interopRequireDefault(_rules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(value) {
  var validationRules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var get = arguments[2];

  var initialValidation = {
    isValid: true
  };

  return validationRules.reduce(function (result, validationRule, index) {
    if (!result.isValid) {
      return result;
    }

    var ruleArray = validationRule instanceof RegExp ? ['regexp'] : validationRule.split(/:(.+)?/);
    var ruleKey = ruleArray[0];
    var rule = _rules2.default[ruleKey] || function () {
      throw new Error('Rule ' + ruleKey + ' is not found');
    };
    var arg = void 0;

    if (validationRule instanceof RegExp) {
      arg = validationRule;
    } else if (typeof ruleArray[1] !== 'undefined') {
      try {
        arg = JSON.parse(ruleArray[1]);
      } catch (e) {
        arg = ruleArray[1];
      }
    } else {
      arg = undefined;
    }

    var isValid = rule(value, arg, get);

    return isValid ? initialValidation : {
      isValid: isValid,
      failedRule: {
        name: ruleKey,
        arg: arg
      },
      errorMessage: _rules2.default._errorMessages[ruleKey] ? _rules2.default._errorMessages[ruleKey](value, arg) : null
    };
  }, initialValidation);
}
//# sourceMappingURL=validate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/utils/validate.js
// module id = 303
// module chunks = 5